import request from '@/utils/request'

// 获取用户消息汇总
export function getUserMessageSum(params) {
  return request({
    url: '/api/manage/message/user/system/count',
    method: 'get',
		params
  })
}

// 获取用户消息列表（分页）
export function getUserMessagePage(params) {
  return request({
    url: '/api/manage/message/user/system/page',
    method: 'get',
		params
  })
}

// 标记用户已读取消息
export function markMessageHaveRead(id) {
  return request({
    url: '/api/manage/message/user/system/read/' + id,
    method: 'get'
  })
}

// 标记用户已读取全部消息
export function markMessageHaveReadAll(params) {
  return request({
    url: '/api/manage/message/user/system/read/all',
    method: 'get',
		params
  })
}

// 弹窗显示消息列表（最多5条）
export function getMessageRemindList() {
  return request({
    url: '/api/manage/message/user/system/remind',
    method: 'get'
  })
}

export default { getUserMessageSum, getUserMessagePage, markMessageHaveRead, markMessageHaveReadAll, getMessageRemindList }
